import {
  ClientTypeList,
  TrackingEventList,
  getAnalyticsConsent,
  getPortalSdk,
} from 'portal-sdk';

import { isDevelopOrSnapshot } from 'bones/utils/environment';
import { isOnPremise } from 'bones/utils/portal/environment';

export const sendHubspotEvent = (
  event: TrackingEventList,
  properties?: Record<string, string>
) => {
  const consent = getAnalyticsConsent();
  const enabled = consent !== null && consent.statistics;

  if (!enabled || isDevelopOrSnapshot() || isOnPremise()) {
    return;
  }

  const portalSDK = getPortalSdk();
  if (!portalSDK) {
    return;
  }

  if (properties) {
    portalSDK.trackEvent({
      event,
      client_type: ClientTypeList.HUBSPOT,
      properties: JSON.stringify(properties),
    });
  } else {
    portalSDK.trackEvent({
      event,
      client_type: ClientTypeList.HUBSPOT,
    });
  }
};
